import { useState, useRef } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputCombo from "../../helpers/InputCombo";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import InputDecimal from "../../helpers/InputDecimal";
import InputDate from "../../helpers/InputDate";
import SortBy from "../../helpers/SortBy";

import search from "../../search.png";
import AppContext from "../../AppContext";
import InputText from "../../helpers/InputText";
import Xlsx from "../../exporter/Xlsx";
import MenuTable from "../../helpers/MenuTable";

import back from "../../back.png";


function LessonOb(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filterParam, setFilterParam] = useState({
  
        p_zajecia_dodatkowe_id: props.id,
        dzien: '',
         

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },
    
     
        limit: 50,
        page: 1,
        pages: 1,
        show: true,

    });


    const [msgData, setMsgData] = useState(0);

      const [legend, setLegend] = useState([
                
        {
            cls:'color_deleted',
            title: 'nieobecny',
            filter: {  filed: "stan_dokumentu", set: "12",  typ: "combo"  },
        },      
        {
            cls:'color_show2',
            title: 'obecny',
            filter: {  filed: "rozliczone", set: "a", typ: "combo"  },
        },
    ]);


    const [tab, setTab] = useState(null);



 

    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0); //do druku

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );




    const changeView = (e ) => {
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = (e) => {

        setView({...view, ["v"]:"list", ["id"]:"-1" }); 
        getTab();
        
    }



   
    const getTab = () => {
            
        
        props.mainView.setProgress(-2);
    

        fetch( Config.url + '/rest_v1_kids,zajecia_dodatkowe_ob', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);  

                       

                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }



    const setStatus = (e) => {

        var status = e.target.getAttribute("atr-status");   //1 - boecny, 0 - nieobecny

        var selected  = 0 ;

        for(var k=0; k< tab.length; k++)
        {
            if(tab[k].selected == '1' ) selected++;
        }


        if( selected < 1)     
        {       
                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dziecka' ,  "ok"  ,null); 
                    return;              
        }



            props.mainView.setProgress(-2);
        

            fetch( Config.url + '/rest_v1_kids,zajecia_dodatkowe_set_st', {
                method: 'POST', 
                body: JSON.stringify({
                    p_zajecia_dodatkowe_id: props.id,
                    status: status,
                    tab: tab,
                }), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                          props.mainView.showDialog( "Sukces", "Status obecności został zmieniony.", "ok" , null);  
                          getTab();          
                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });

        

    }





    const changeSelectedAll = (e) => {

        var t = JSON.parse(JSON.stringify(tab));

        var first = t[0].selected;

        for(var k=0; k< t.length; k++)
        {
            if(first == '0')
            {
              t[k].selected = '1';
            }else   t[k].selected = '0';
        }

        setTab(t);
    }

     const changeSelected = (e) => {
        
            var inx = e.target.getAttribute('atr-inx');   
    

            if(tab[inx]['selected'] == '0') { 
                tab[inx]['selected'] = '1';
            }else 
            if(tab[inx]['selected'] == '1')  tab[inx]['selected'] = '0';


            setTab(  JSON.parse(JSON.stringify(tab)) );
            
    }

    
    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }


    const filterClear = () => {
  
       

        setFilterParam({
                 
           p_zajecia_dodatkowe_id: props.id,
            dzien: '',
          
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },
                                       
            limit: 50,
            page: 1,
            show: true
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }

    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }



 
    
    if(tab == null)
        {
            setTab([]);
            getTab();
        
    
            return <div>
                ...
            </div>
        }
    
    
        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
            setView( {
                v:'list',
                id: -1
            });
        }


 

    var sortList = [                
        {column: "nazwa", name: "Nazwa"  }, 
      
]



    var selected  = 0 ;

    for(var k=0; k< tab.length; k++)
        {
            if(tab[k].selected == '1' ) selected++;
        }

    if(msgData == '0')
    {
        setMsgData(1);
         props.mainView.showDialog( "Powiadomienie", "Wybierz dzień zajęć.", "ok" , null);  
    }



    return <div className="view_content">
 

                
                <div className="bg_center">

                        <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>
                        <br/>                

                        <h3>{props.title}</h3>
                        <br/>


                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 


                {
                    filterParam.show == true  &&
                    <div className="table_filter">

                                     
                        <div className="filter_controll">   
                            <label>Dzień: </label>                             
                            <InputDate   userData={props.userData} value={filterParam.dzien}   valChange={valChangeListener} goNext={goNextNew} name="dzien" placeholder={"Dzień: "}   />
                       </div> 
 
                         <div className="filter_btn">
                            <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                            <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                        </div>

                  </div>
                } 
                           


                            <div className="table_widget">
                                            <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                            
                                                &nbsp; &nbsp;

                                            <InputLegend items={legend}    valChange={valChangeListener} />

                                            &nbsp; &nbsp;
                                            <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title="Zajęcia dodatkowe" />   
                                            <Csv tabRef={tab2Ref}  title="zajęciadodatkowe.csv" />                  
                                            <Xlsx tabRef={tab2Ref} title="zajęciadodatkowe.xlsx" />                  
                                            <Print tabRef={tab2Ref} />

                                            <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                                </div>

                                <div className="table_mass">  
                                    <div className="title_mass">Operacje masowe (zaznaczono: {selected}) </div>
                                    &nbsp;

                                    &nbsp;
                                    <span className="btn" atr-status="1"  onClick={setStatus}  >Ustaw jako obecny</span>
                                    &nbsp;
                                    <span className="btn" atr-status="0"  onClick={setStatus}  >Ustaw jako nieobecny</span>

                                </div>


                                <div ref={tabRef} className="gohide">
                               
                                </div>



                            <div className="scorll_x">
                                <table className="table" >
                                                    <thead>
                                                        <tr className="header">                                                                                                       
                                                            <td className="td_left">LP</td>  
                                                            <td className="link_normal" onClick={changeSelectedAll}>Z</td>                                                                                                                                                                                                                                                                                                               
                                                            <td>Data</td>                                                                                                                                                                                                                                                                                                                    
                                                            <td>Godzina zajęć</td>                                                                                                                                                                                                
                                                            <td>Grupa</td>                                                                                                                                                                                                
                                                            <td>Dziecko</td>                                                                                                                                                                                                
                                                            <td className="td_right">Status</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {
                                                            tab.map( (row,ix) => {

                                                              
                                                                var rowStyle = " row ";
                                                                if(ix % 2 == 0 )rowStyle = " row2 ";

                                                                if(row.stan == "1") rowStyle = rowStyle + " color_show2 ";
                                                                if(row.stan == "0") rowStyle = rowStyle + " color_deleted ";

                                                                var isChecked = false;
                                                                if(row.selected == '1') isChecked = true;

                                                                return <tr className={rowStyle}>                                                                                                       
                                                                    <td>{ix+1}</td>   
                                                                    <td className="gocenter">
                                                                       <input type="checkbox" atr-inx={ix} onChange={changeSelected} checked={isChecked} />
                                                                    </td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
                                                                    <td className="gocenter">{row.dzien}</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
                                                                    <td className="gocenter">{row.godzina}</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
                                                                    <td className="gocenter">{row.grupa.nazwa}</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
                                                                    <td>{row.dziecko.nazwisko} {row.dziecko.imie}</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
                                                                    <td className="gocenter">
                                                                          {
                                                                             row.stan == "1" &&
                                                                             <span>Obecny</span>
                                                                          }
                                                                          {
                                                                             row.stan == "0" &&
                                                                             <span>Nieobecny</span>
                                                                          }
                                                                           {
                                                                             row.stan == "2" &&
                                                                             <span> - - - </span>
                                                                          }
                                                                    </td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
                                                                </tr>    

                                                            } )
                                                        }

                                                 
                                                    </tbody>
                                </table>
                            </div>


                </div>

                  <br/>                                                            
                <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>
                <br/> 


           </div>
}




export default LessonOb;